import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

type AdyenContextType = {
  adyenResponse?: string;
};

const AdyenContext = React.createContext<AdyenContextType>({});

const AdyenProvider = ({ children }: { children: React.ReactNode }) => {
  const [adyenResponse, setAdyenResponse] = useState<string>();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const resultCode = new URLSearchParams(location.search).get("resultCode");
    if (resultCode) {
      setAdyenResponse(resultCode);
      navigate(`${location.pathname}?depositResult=${resultCode}`);
    }
  }, [location.pathname, location.search, navigate]);

  return <AdyenContext.Provider value={{ adyenResponse }}>{children}</AdyenContext.Provider>;
};

export { AdyenContext, AdyenProvider };
